import './Footer.css'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img 
                src="/assets/logo/meq-logo.png" 
                alt="MEQ Labs Logo" 
                className="footer-logo-image"
              />
              <p className="footer-description">
                Cutting-edge AgTech platform showcasing advanced red meat grading technology and data analytics solutions for industry leaders.
              </p>
            </div>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Platform</h3>
            <ul className="footer-links">
              <li><a href="#dashboards" className="footer-link">Dashboards</a></li>
              <li><a href="#analytics" className="footer-link">Analytics</a></li>
              <li><a href="#reports" className="footer-link">Reports</a></li>
              <li><a href="#integrations" className="footer-link">Integrations</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Support</h3>
            <ul className="footer-links">
              <li><a href="#documentation" className="footer-link">Documentation</a></li>
              <li><a href="#help" className="footer-link">Help Center</a></li>
              <li><a href="#contact" className="footer-link">Contact Us</a></li>
              <li><a href="#status" className="footer-link">System Status</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Company</h3>
            <ul className="footer-links">
              <li><a href="#about" className="footer-link">About</a></li>
              <li><a href="#careers" className="footer-link">Careers</a></li>
              <li><a href="#privacy" className="footer-link">Privacy Policy</a></li>
              <li><a href="#terms" className="footer-link">Terms of Service</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              © {currentYear} MEQ Insights. All rights reserved.
            </p>
            <div className="footer-bottom-links">
              <a href="#security" className="footer-link">Security</a>
              <a href="#compliance" className="footer-link">Compliance</a>
              <a href="#cookies" className="footer-link">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer 